import React from 'react';
import { Link } from 'react-router-dom';
import './LandingPage.css';
import { useLanguage } from '../contexts/LanguageContext';
import { getAllArticles } from '../utils/blogUtils';

const BlogPage = () => {
  const { t, isRTL, currentLanguage } = useLanguage();
  const articles = getAllArticles(t);

  // Map language codes to locale codes for date formatting
  const localeMap = {
    en: 'en-US',
    es: 'es-ES',
    fr: 'fr-FR',
    he: 'he-IL',
    zh: 'zh-CN'
  };
  const locale = localeMap[currentLanguage] || 'en-US';

  return (
    <div className="landing-container" dir={isRTL ? 'rtl' : 'ltr'}>
      <header className="landing-header">
        <h1>{t('blog') || 'Blog'}</h1>
        <p>{t('blogSubtitle') || 'Latest articles, tips, and updates from SafaCards'}</p>
      </header>
      <main className="landing-main" style={{ textAlign: isRTL ? 'right' : 'left', maxWidth: '800px', margin: '0 auto' }}>
        {articles.length === 0 ? (
          <section style={{ textAlign: 'center', padding: '2rem 0' }}>
            <p style={{ fontSize: '1.1rem', color: '#666', marginBottom: '2rem' }}>
              {t('blogComingSoon') || 'Blog posts coming soon! Check back later for articles, tips, and updates about language learning with SafaCards.'}
            </p>
            <div style={{ marginTop: 32, textAlign: 'center' }}>
              <Link to="/home" className="btn btn-primary">{t('backToHome')}</Link>
            </div>
          </section>
        ) : (
          <section style={{ padding: '2rem 0' }}>
            {articles.map((article) => (
              <article
                key={article.id}
                style={{
                  marginBottom: '2.5rem',
                  padding: '1.5rem',
                  background: '#fff',
                  borderRadius: '12px',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                  border: '1px solid #eee'
                }}
              >
                <h2 style={{ marginTop: 0, marginBottom: '0.5rem', fontSize: '1.5rem' }}>
                  <Link
                    to={`/blog/${article.slug}`}
                    style={{
                      color: '#386641',
                      textDecoration: 'none',
                      fontWeight: 600
                    }}
                  >
                    {article.title}
                  </Link>
                </h2>
                <p style={{
                  color: '#666',
                  fontSize: '0.9rem',
                  marginBottom: '1rem',
                  fontStyle: 'italic'
                }}>
                  {new Date(article.date).toLocaleDateString(locale, {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  })} • {article.author}
                </p>
                <p style={{
                  color: '#555',
                  lineHeight: '1.6',
                  marginBottom: '1rem'
                }}>
                  {article.excerpt}
                </p>
                <Link
                  to={`/blog/${article.slug}`}
                  className="btn btn-secondary"
                  style={{ display: 'inline-block' }}
                >
                  {t('readMore') || 'Read More'}
                </Link>
              </article>
            ))}
            <div style={{ marginTop: 32, textAlign: 'center' }}>
              <Link to="/home" className="btn btn-primary">{t('backToHome')}</Link>
            </div>
          </section>
        )}
      </main>
      <footer className="landing-footer">
        <div className="footer-links">
          <Link to="/about">{t('about')}</Link>
          <Link to="/privacy">{t('privacyPolicy')}</Link>
          <Link to="/terms">{t('termsOfService')}</Link>
          <Link to="/support">{t('supportTitle') || 'Support'}</Link>
        </div>
        <p>&copy; {new Date().getFullYear()} SafaCards App. {t('allRightsReserved')}</p>
      </footer>
    </div>
  );
};

export default BlogPage;

